module.exports = __webpack_public_path__ + "media/images/shark/Tilden-p-800-a847305a8cda872e44bded9a0567508d.jpeg";